<template>
    <b-card
        :title="title"
        :loading="loading"
        :error-message="errorMessage"
        @cancel="$emit('cancel')"
        @submit="mode === 1 ? create() : update()"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >
        <b-text-field
            v-model="networkRegion.name"
            :label="translations.region[lang]"
            no-top-margin
        ></b-text-field>
    </b-card>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/stores/networkRegions";

export default {
    name: "StoreForm",

    mixins: [translations],

    props: {
        mode: Number,
    },

    data: () => ({}),

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "resetSuccess",
            "resetValidation",
        ]),
        ...mapState("loyaltyPanel/stores/networkRegions", ["networkRegion"]),

        lang() {
            return this.$route.params.lang;
        },

        title() {
            return this.mode === 1
                ? this.translations.addRegion[this.lang]
                : this.translations.updateRegion[this.lang];
        },
    },

    methods: {
        ...mapMutations(["setResetSuccess", "setResetValidation"]),
        ...mapActions("loyaltyPanel/stores/networkRegions", [
            "create",
            "update",
        ]),
    },
};
</script>
